import React from "react";
import logger from "logger";
import { getHumanReadableTimePassedSinceThisInstance } from "Utils/Common";
import Tooltip from "@material-ui/core/Tooltip";

const getInstanceFromValidity = (validityRemainingSecs) => {
  var currentTimeMillis = new Date().getTime();
  return currentTimeMillis + validityRemainingSecs * 1000;
};

const ValidityCounter = (props) => {
  const { validityRemainingSecs } = props;
  const instanceMillis = getInstanceFromValidity(validityRemainingSecs);
  const [timeString, setTimeString] = React.useState(
    getHumanReadableTimePassedSinceThisInstance(instanceMillis)
  );

  React.useEffect(() => {
    const timer = setInterval(() => {
      const timeString = getHumanReadableTimePassedSinceThisInstance(
        instanceMillis
      );
      setTimeString(timeString);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Tooltip title={timeString.timeString}>
      <span>{timeString.timeapprox}</span>
    </Tooltip>
  );
};

export default ValidityCounter;
